module.exports = __webpack_public_path__ + "static/img/sun1.d550607.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/sun1.png
// module id = rq4W
// module chunks = 0